import React from 'react';
import PropTypes from 'prop-types';

import { partnerCmsClient } from 'src/lib/contentful-client';
import { ContentfulTemplates } from 'src/lib/constants';
import { TemplateFieldShape } from 'src/lib/prop-types';
import { TemplateSwitch } from 'src/templates';
import { optimizeContentfulImages } from 'src/lib/image-helpers';

const propTypes = {
  fields: PropTypes.shape({ fields: TemplateFieldShape.isRequired }),
};

const PartnerOverview = ({ fields }) => {
  return <TemplateSwitch {...fields} />;
};
PartnerOverview.propTypes = propTypes;

export async function getStaticProps({ preview }) {
  const entries = await partnerCmsClient.getEntries({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    content_type: ContentfulTemplates.PARTNER_DIRECTORY,
    include: 10,
    'fields.pageSlug': 'partner-directory',
  });

  const fields = entries.items[0];

  return {
    props: { fields: optimizeContentfulImages(fields), preview: !!preview },
  };
}

export default PartnerOverview;
